import { Box, Typography, useTheme } from "@mui/material";
import { addToRefsGeneric } from "../../utils/funtions";
import { useEffect, useRef } from "react";
import gsap from "gsap";

type TitleProps = {
  title?: string;
  subTitle?: string;
  bgColor?: string;
  boxShadow?: boolean;
  topShadow?: boolean;
  fontSizeTitle?: number;
};
export const Title = ({
  title,
  subTitle,
  bgColor,
  boxShadow,
  fontSizeTitle,
  topShadow,
}: TitleProps) => {
  const titleRef = useRef<HTMLDivElement[]>([]);
  const addTitleRef = addToRefsGeneric(titleRef);
  const theme = useTheme();

  useEffect(() => {
    const ctx = gsap.context(() => {
      if (!titleRef.current) return;

      gsap.fromTo(
        titleRef.current,
        { y: 90, opacity: 0, transformPerspective: 1000, rotateX: 0.01 },
        {
          y: 0,
          opacity: 1,
          ease: "power1",
          scrollTrigger: {
            trigger: titleRef.current,
            start: "top 95%",
            end: "bottom 5%",
            toggleActions: "play reverse play reverse",
          },
        }
      );
    });
    return () => ctx.revert();
  }, []);

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        backgroundColor: bgColor,
        width: "100%",
        willChange: "transform",
        position: "relative",
        zIndex: 9,
        paddingBlock: {xs: 8, md: 5},
        boxShadow: {
          xs:  undefined,
          md: boxShadow ? "0px 0px 40px 50px #000000" : undefined,
        },
      }}
    >
      {topShadow && (
        <Box
          width="100%"
          position="absolute"
          top={0}
          boxShadow={{xs:undefined,  md: "#ffffff 0px 0px 50px 80px"}}
        />
      )}

      <Typography
        ref={addTitleRef}
        sx={{
          fontSize: {xs: 25, md: fontSizeTitle || 30},
          textTransform: "uppercase",
          fontWeight: 800,
          background: "linear-gradient(90deg, #f8d8cb,#dd7247)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
        }}
      >
        {title}
      </Typography>
      <Typography
        ref={addTitleRef}
        sx={{
          color:
            bgColor === "black"
              ? theme.palette.background.paper
              : theme.palette.secondary.main,
          fontSize: {xs: 25, md: 60},
          textTransform: "uppercase",
          fontWeight: 800,
        }}
      >
        {subTitle}
      </Typography>
    </Box>
  );
};
